import { useCallback } from 'react'
import { useTranslations } from '@/core/translation'
import { GetDurationValueTextProps } from './TimeRangeSlider.types'

export const useTimeRangeSlideUtils = () => {
  const t = useTranslations('components')

  const getDurationValueText = useCallback(
    ({ value, min, max }: GetDurationValueTextProps) => {
      const hasSelectedValue = value.min !== min || value.max !== max
      const isMinZero = value.min === 0

      if (hasSelectedValue) {
        if (isMinZero)
          return t('timeRangeSlider.durationUnderHours', {
            value: `${value.max}`,
          })

        return t('timeRangeSlider.durationHours', {
          value: `${value.min} - ${value.max}`,
        })
      }

      return t('timeRangeSlider.durationAny')
    },
    [t],
  )

  return {
    getDurationValueText,
  }
}
